var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h1',[_vm._v("编辑代办事项")]),_c('input',{staticClass:"new-todo",attrs:{"placeholder":"输入您的代办事项 ?"},domProps:{"value":_vm.name},on:{"input":_vm.handleChange,"keyup":_vm.handleSubmit}})])}
var staticRenderFns = []

export { render, staticRenderFns }